module.exports = __webpack_public_path__ + "fonts/iconfont.d1e559b6.woff2";